<template>
    <div class="drag-body" :class="currLayoutData.area_style.color">
        <template v-if="currLayoutData.direction != 2">
            <div v-if="isPreview" class="drag-area-title" style="font-size: var(--col-text-font)">{{ currLayoutData.area_name }}</div>
            <input v-else class="drag-area-title" style="font-size: var(--col-text-font)" type="text" @change="changeLayoutData($event,'area_name')" v-model="currLayoutData.area_name" />
        </template>
        <div v-for="(item,row_index) in currLayoutData.seat_list" :key="item.row_id" class="drag-area-row">
            <div v-if="isPreview" class="row-title" style="font-size: var(--col-text-font);width: var(--row-text-width);height: var(--row-text-height)">{{item.row_name}}</div>
            <input v-else class="row-title" style="font-size: var(--col-text-font);width: var(--row-text-width);height: var(--row-text-height)" type="text" @change="changeLayoutData($event,'row_name',{row_id:item.row_id})" v-model="item.row_name" />
            <!-- 筛选模式时  selection-highlight为选中高亮样式 --> 
            <div v-for="(col,col_index) in item.col" :key="col.desk_id" class="drag-area-col" :class="{'col-segement':(segementSign.indexOf(col_index)!=-1)}">
                <template v-for="(seat,seat_index) in col.seat_item">
                    <div
                        class="drag-area-col-inner"
                        v-if="seat.is_valid == '1' || isShowInvalidSeat"
                        :key="seat.seat_id"
                        :class="setSelectionEl(seat)"
                        :ref="seat.person|setSelectionElRef">
                        <template v-if="row_index == 0">
                            <div style="font-size: var(--col-text-font)" v-if="isPreview" disabled class="col-title">{{col.desk_name}}</div>
                            <input v-else style="font-size: var(--col-text-font)" disabled class="col-title" @change="changeLayoutData($event,'desk_name',{row_id:item.row_id,desk_id:col.desk_id})" v-model="col.desk_name"/>
                        </template>
                        <div 
                        style="margin-top:10px;widht:var(--col-text-width);height:var(--col-text-height);" 
                        class="col-text" 
                        draggable="true" 
                        :layout-index="layoutIndex"
                        :row-index="row_index"
                        :col-index="col_index"
                        :seat-index="seat_index"
                        :is-valid="seat.is_valid"
                        @dragstart="handleDragStart" 
                        @dragover.prevent="handleDragOver"
                        @dragenter="handleDragEnter" 
                        @dragend="handleDragEnd"
                        @click="handleClickSeatEvent($event,'click',currLayoutData.area_id,item.row_id,col.desk_id,seat.seat_id)"
                        @contextmenu.prevent="handleClickSeatEvent($event,'contextmenu',currLayoutData.area_id,item.row_id,col.desk_id,seat.seat_id)" 
                        :class="{'empty' : !seat.person,'is_valid' : (isShowInvalidSeat && seat.is_valid == '0')}">
                          <span :style="isMaxParentArea((seat.person||{}).name)" v-if="(seat.person||{}).name">{{(seat.person || {}).name}}</span> 
                        </div>
                    </div>
                    <!-- 为首行时占位使用 -->
                    <div v-else-if="row_index==0" :key="seat.seat_id" class="drag-area-col-inner" :ref="seat.person|setSelectionElRef">
                        <div v-if="isPreview" class="col-title" style="font-size: var(--col-text-font)">{{ col.desk_name }}</div>
                        <input v-else class="col-title" style="font-size: var(--col-text-font)" disabled @change="changeLayoutData($event,'desk_name',{row_id:item.row_id,desk_id:col.desk_id})" v-model="col.desk_name"/>
                        <div style="height:var(--col-text-height);margin-top:10px">
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <template v-if="currLayoutData.direction == 2">
            <div v-if="isPreview" class="drag-area-title mt10" style="font-size: var(--col-text-font)">{{ currLayoutData.area_name }}</div>
            <input v-else class="drag-area-title mt10" style="margin-bottom:0;margin-top:15px;font-size: var(--col-text-font)" type="text" @change="changeLayoutData('area_name',{area_name:currLayoutData.area_name})" v-model="currLayoutData.area_name"/>
        </template>
    </div>
</template>

<script>
import areaMin from './area-mixin';
import dragMin from '@/components/drag-mixin';
export default {
    mixins: [areaMin,dragMin],
    name: "d_juyuan",
    components: {},
    props: {
        isPreview:{
            type:Boolean,
            default:false,
        }
    },
    data() {
        return {
            segementSign: [] // 分段标记位
        }
    },
    methods: {},
    mounted() {
    },
    created() {
        let arr = (this.currLayoutData || {}).desk_type?.segement || [];
        arr = Array.isArray(arr) ? arr : arr.split(',');
        let segementSign = [],
            n = 0;
        for (let i = 0, l = arr.length; i < l; i++) {
            n += ~~arr[i];
            segementSign.push(n);
        }
        this.segementSign = segementSign;
    }
}
</script>

<style lang="less" scoped>
@import url('~@/assets/css/area-content.less');
.mt10{
    margin-top: 10px !important;
}
</style>